export const environment = {
    production: true,
    authApiUrl: 'https://auth.api.preprod.1minutepourmoncoeur.fr',
    apiUrl: 'https://api.preprod.1minutepourmoncoeur.fr/1.0',
    pmpApiUrl: 'https://pmp.api.preprod.1minutepourmoncoeur.fr/',
    pmpSockets: 'wss://pmp.api.preprod.1minutepourmoncoeur.fr/',
    authfrontURL: 'https://auth.preprod.1minutepourmoncoeur.fr',
    psp: 'https://preprod.1minutepourmoncoeur.fr',
    psa: 'https://alerts.preprod.1minutepourmoncoeur.fr',
    newcardUrl: 'https://(alerts.)?preprod.1minutepourmoncoeur.fr.*',
    cookieDomain: '.1minutepourmoncoeur.fr',
    insiConsult: 'https://ins.preprod.1minutepourmoncoeur.fr',
    helpPage: 'https://newcard.io/espace-daide/',
    helpInclusionCardioPage: 'https://newcard.io/inclure-un-patient-en-insuffisance-cardiaque-mpc/',
    helpInclusionNephroPage: 'https://newcard.io/inclure-un-patient-insuffisant-renal-mpr-transplante-renal/',
    jfse: {
        urlkitWindows: 'https://updates.jfse.fr/files/lecteur/3.37/setup_lsv_win_3.37-default.exe',
        urlKitMac: 'https://updates.jfse.fr/files/lecteur/3.37/setup_lsv_mac_3.37-default.pkg.zip',
        hostToConfig: 'resip-fse-hg-test.cegedim.com',
        portToConfig: 6081,
        daemonConfigPanelUrl: 'http://127.0.0.1:8888',
        apcv: false,
        vital: false,
        scor: false,
        enableSecured: false,
        enableUnsync: false,
        enableDegraded: false,
    },
};
